import { BeltRank, TechniqueType } from '../types';

export const CATEGORY_GAP = 30;
export const NODE_WIDTH = 200;
export const NODE_HEIGHT = 50;
export const NODE_GAP_X = 16;
export const NODE_GAP_Y = 12;
export const GROUP_PADDING_TOP = 50;
export const GROUP_PADDING = 24;
export const COLUMNS_PER_GROUP = 3;
export const TIER_PADDING_TOP = 80;
export const TIER_PADDING_BOTTOM = 40;
export const TIER_PADDING_X = 40;

export const TIER_LABELS: Record<BeltRank, string> = {
  [BeltRank.WhiteBelt]: 'White Belt',
  [BeltRank.BlueBelt]: 'Blue Belt',
  [BeltRank.PurpleBelt]: 'Purple Belt',
  [BeltRank.BrownBelt]: 'Brown Belt',
  [BeltRank.BlackBelt]: 'Black Belt',
};

// Belt-inspired background colors (subtle, dark-mode friendly)
export const TIER_COLORS: Record<BeltRank, string> = {
  [BeltRank.WhiteBelt]: '#242430',     // White belt
  [BeltRank.BlueBelt]: '#1a2a3e',      // Blue belt
  [BeltRank.PurpleBelt]: '#2a1a3e',          // Purple belt
  [BeltRank.BrownBelt]: '#2e1f14',            // Brown belt
  [BeltRank.BlackBelt]: '#1a1a1a',            // Black belt
};

// Accent colors for tier labels
export const TIER_ACCENT_COLORS: Record<BeltRank, string> = {
  [BeltRank.WhiteBelt]: '#e0e0e0',
  [BeltRank.BlueBelt]: '#4A90D9',
  [BeltRank.PurpleBelt]: '#9B59B6',
  [BeltRank.BrownBelt]: '#A0724A',
  [BeltRank.BlackBelt]: '#333333',
};

// Sort order for technique types (techniques are grouped by type, then A–Z).
// Derived from the TechniqueType order in types.ts, so Library and the creator
// pages order identically without either keeping its own copy.
export const TYPE_ORDER: Record<string, number> = Object.fromEntries(
  Object.values(TechniqueType).map((v, i) => [v, i]),
);

// Display names for the types, derived from the same enum so nothing drifts:
// the keys in types.ts are already the words we show ("Submission", "Escape").
export const TYPE_LABELS: Record<string, string> = Object.fromEntries(
  Object.entries(TechniqueType).map(([label, v]) => [v, label]),
);
